import styled from 'styled-components';
import AnimatedLoader from '.';

export default styled(AnimatedLoader)`
  width: 100%;
  height: 100%;
  position: relative;
  img{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;



// WEBPACK FOOTER //
// ./app/components/AnimatedLoader/centred.js